import React from 'react';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
// import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';

interface DatePickerComponentProps {
  label: string;
  value: string | null;
  onChange: (date: string | null) => void;
}

const DatePickerComponent: React.FC<DatePickerComponentProps> = ({ label, value, onChange }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        label={label}
        inputFormat="dd-MMM-yyyy"
        onChange={(newValue: Date | null) => {
          if (newValue && moment(newValue).isValid()) {
            onChange(moment(newValue).format('YYYY-MM-DD').toString());
          }
        }}
        value={value}
        renderInput={(params) => (
          <TextField
            variant="standard"
            fullWidth
            {...params}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {value && (
                    <InputAdornment position="end">
                      <IconButton onClick={() => onChange(null)} edge="end">
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  )}
                  {params.InputProps?.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default DatePickerComponent;
